export default function registrationResendCountdown(initialSeconds) {
  let timer = null

  return {
    remainingSeconds: Math.max(0, Number.parseInt(initialSeconds, 10) || 0),

    get waiting() {
      return this.remainingSeconds > 0
    },

    init() {
      if (!this.waiting) {
        return
      }

      timer = window.setInterval(() => {
        this.remainingSeconds = Math.max(0, this.remainingSeconds - 1)

        if (!this.waiting) {
          window.clearInterval(timer)
          timer = null
        }
      }, 1000)
    },

    destroy() {
      if (timer !== null) {
        window.clearInterval(timer)
      }
    }
  }
}
